import React, { useState, useEffect } from "react"

import {
  CustomForm,
  SubmitButton,
  FormContainer,
  FormTitle,
  FormText,
  FormInputHeader,
  FormTextInput,
  FormCheckbox,
  SubmittedMessage,
} from "./style"

const FormEg = ({ attribs }) => {
  const [submitted, setSubmitted] = useState(false)

  const [formstate, setFormState] = useState({
    action: "",
    xnQsjsdp: "",
    xmIwtLD: "",
  })

  useEffect(() => {
    setFormState({
      action: "https://crm.zoho.com/crm/WebToLeadForm",
      returnUrl: `${window.location.href.split("#")[0]}#thanks`,
      xnQsjsdp:
        "e3b2a08acb3921bd870e27815f22871feed208ac96419c63cb6645312918b279",
      xmIwtLD:
        "dd2ec1679d4b24ac5474202a1c89b037f984ef8e5f9ae2aee2e137707835e182",
    })

    if (window.location.hash === "#thanks") {
      setSubmitted(true)
    }
  }, [])

  return (
    <FormContainer id="thanks">
      {submitted && (
        <SubmittedMessage>
          Thanks for getting in contact! <br />
          We'll be in touch shortly.
        </SubmittedMessage>
      )}
      {!submitted && (
        <>
          <FormTitle dangerouslySetInnerHTML={{ __html: attribs.title }} />
          <FormText dangerouslySetInnerHTML={{ __html: attribs.subtitle }} />
          <CustomForm
            noValidate
            noAjax
            action={formstate.action}
            name="contact"
          >
            <FormTextInput name="Lead Source" type="hidden" value="Campaign" />
            <FormTextInput
              name="xnQsjsdp"
              type="hidden"
              value={formstate.xnQsjsdp}
            />
            <FormTextInput
              name="xmIwtLD"
              type="hidden"
              value={formstate.xmIwtLD}
            />
            <FormTextInput name="actionType" type="hidden" value="TGVhZHM=" />
            <FormTextInput name="zc_gad" type="hidden" value="" />
            <FormTextInput
              name="returnURL"
              type="hidden"
              value={formstate.returnUrl}
            />

            <FormInputHeader>First name</FormInputHeader>
            <FormTextInput name="First Name" error="Please enter a username" />
            <FormInputHeader>Last name</FormInputHeader>
            <FormTextInput name="Last Name" error="Please enter a username" />
            <FormInputHeader>Email address</FormInputHeader>
            <FormTextInput
              type="email"
              name="Email"
              error="Please enter a valid email"
            />
            <FormInputHeader>Mobile</FormInputHeader>
            <FormTextInput
              type="text"
              name="Mobile"
              error="Please enter a valid phone"
            />
            <FormInputHeader>Your message</FormInputHeader>
            <FormTextInput
              name="LEADCF5"
              type="textarea"
              error="Please enter a message"
            />
            <FormCheckbox
              name="LEADCF101"
              label="Yes, I'd like to receive news and updates from Johnston Grocke"
              value="on"
              type="checkbox"
            />
            <img
              id="tr_img_dd2ec1679d4b24ac5474202a1c89b037f984ef8e5f9ae2aee2e137707835e182"
              alt=""
              src="https://crm.zohopublic.com/crm/WebFormAnalyticsServlet?rid=dd2ec1679d4b24ac5474202a1c89b037f984ef8e5f9ae2aee2e137707835e182gide3b2a08acb3921bd870e27815f22871feed208ac96419c63cb6645312918b279gida378f81585080d3b6fb1acbec6638b71gid885e3c1045bd9bdcc91bdf30f82b5696gid14f4ec16431e0686150daa43f3210513"
              style={{ display: "none" }}
            />
            <SubmitButton submit label="Submit" />
          </CustomForm>
        </>
      )}
    </FormContainer>
  )
}

export default FormEg
